const SQUARE_WIDGET_URL =
  "https://book.squareup.com/appointments/kmpgd2bfo1foj2/location/LF7HYF29DZERB";

const SquareBookingWidget = () => (
  <iframe
    data-testid="booking-widget-container"
    src={SQUARE_WIDGET_URL}
    title="Book an appointment with G5 Auto Restyling"
    allow="payment app.squareup.com"
    className="w-full rounded-xl bg-white border-0"
    style={{ minHeight: 720, height: "100%" }}
  />
);

export default SquareBookingWidget;
